import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { Hostel } from '@app/services/api/api.service';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-hostel-image-carousel',
  templateUrl: './hostel-image-carousel.component.html',
  styleUrls: ['./hostel-image-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class HostelImageCarouselComponent implements AfterViewInit, OnDestroy {
  @ViewChild('sliderRef', { static: false })
  sliderRef: ElementRef<HTMLElement>;

  @Input()
  public hostel?: Hostel;

  public slider: KeenSliderInstance | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  get isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  ngAfterViewInit() {
    if (!this.isServer) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: true,
        slides: {
          origin: 'center',
          perView: 1,
        },
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}
